import React from 'react';
import { Card } from "react-bootstrap";
import face_image from "../../assets/img/faceGergelyManasses.jpg";
import ShowMoreText from "react-show-more-text";
import proj_image from "../../assets/img/projManassesG_central_bank.png";

const Gergely_Manasses_central_bank = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_image} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_image}
              /* this will be the text on the banner */
              alt="Central bank collateral management - spread analysis"
            />{" "}
            <p className="text7">Gergely Manasses </p>
            <br />
            <p className="text8">
              Lead Risk Analyst{" "}
            </p>
            <p className="text8">Central Bank of Hungary</p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            Central banks provide secured borrowing facilities to the banking system as part of their normal 
            monetary policy toolkit. Lending serves several central banking purposes: by providing preferential 
            loans, the central bank can stimulate the lending activity of the banking system; interest paid on 
            loans is one of the channels of monetary transmission; the central bank credit line can be an 
            important source of liquidity for credit institutions. In other words, the existence and proper 
            functioning of the lending facility is a priority for both the central bank and the credit 
            institution. Central bank lending is provided only in secured form. The exercise of monetary policy 
            is a fundamental central bank task defined by law, and secured lending is part of this, which 
            presupposes transparency, accountability, and equal treatment. In the case of unsecured lending, 
            central banks would be more likely to face losses in their lending activities. As a public 
            institution, losses incurred in relation to public funds - in addition to being a cost to taxpayers 
            - pose a serious reputational risk for central banks.
            <br/>
            <br/>
            The collateral management framework is also influenced by monetary policy, risk management and 
            operational considerations. In the case of a collateralised debt instrument, a significant part of 
            the credit structure is the definition of collateral management principles and procedures. Central 
            banks need to develop a system that can be operated efficiently (both on the central bank and credit 
            institution side), minimizes the central bank's risks, while at the same time adequately supporting 
            the central bank's objective for which the debt instrument was designed.
            <br/>
            <br/>
            An important aspect is the market liquidity of collaterals, some asset classes (e.g. government 
            securities) are traded in large volumes, in which case actual, reliable prices are available on a 
            daily basis, while other asset classes are less liquid, there are no reliable prices. These are 
            priced using theoretical pricing, using a selected yield curve and a spread specific to the asset 
            type. (In the case of credit claims, it is typical that the central bank evaluates the asset at 
            nominal value instead of price, reflecting pricing uncertainties in the haircut.)
            <br/>
            <br/>
            The aim of the research is to determine the spreads observable in the given market based on the 
            pricing of benchmark securities corresponding to the separate asset classes and use them to 
            determine the value of less liquid securities.
            <br/>
            <br/>
            Methodology for determining spreads:
            <ul>
                <li>
                    Use of uniform spreads per rating and maturity
                </li>
                <li>
                    Bloomberg, investment rate bond universe: the euro credit market as a proxy to be used (2000 issue)
                </li>
                <li>
                    Consistency regarding maturity and rating
                </li>
                <li>
                    Following market trends
                </li>
            </ul>
            <br/>
            Used models and indicators:
            <ul>
                <li>
                    Svensson yield curve model
                </li>
                <li>
                    Value at Risk (VaR) and Expected Shortfall indicator
                </li>
            </ul>
            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Gergely_Manasses_central_bank;